import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { cssVar } from '@chakra-ui/theme-tools'

import { colors } from '../colors'

const $bg = cssVar('tooltip-bg')
const $fg = cssVar('tooltip-fg')
const $arrowBg = cssVar('popper-arrow-bg')

const baseStyle = defineStyle({
  [$bg.variable]: colors.presets.turquoise[100],
  [$fg.variable]: colors.presets.neutral[0],
  [$arrowBg.variable]: $bg.reference,
  borderRadius: '2px',
  fontWeight: '500',
  fontSize: '12px',
  padding: '8px 16px',

  _light: {
    [$bg.variable]: colors.presets.turquoise[100],
    [$fg.variable]: colors.presets.neutral[0],
  },
  _dark: {
    [$bg.variable]: colors.presets.turquoise[100],
    [$fg.variable]: colors.presets.neutral[0],
  },
})

export const tooltipTheme = defineStyleConfig({
  baseStyle: baseStyle,
})
